export class TestSelector {
    public static getSelector(selectorName: string = '') {
        return selectorName ? { 'data-testid': selectorName } : {};
    }
}
